import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@mui/styles";

import {
  LOCATIONS_PLAN_TYPE,
  OVERRIDES_PLAN_TYPE,
  PICKUP_PLAN_TYPE,
} from "../../consts/planTypes";
import { palette } from "../../theme/palette";

import { selectedPostcodesSelector } from "../../reducers/ownApp/selectors";
import {
  applyEdit,
  cancelEdit,
  optimiseRouteEditImpact,
  editPostcodesOverrides,
  editPostcodesPickup,
} from "../../reducers/matrixProfile/thunkActions";
import {
  getMatrixProfileType,
  overlayDetailsSelector,
  routesAffectedByEditSelector,
  depotRoutesOptimisedSelector,
} from "../../reducers/matrixProfile/selectors";
import { artificialPostcodeInEditSelector } from "../../reducers/depot/selectors";
import {
  applyArtificialPostcodeEdit,
  cancelArtificialPostcodeEdit,
} from "../../reducers/depot/thunkActions";

import { View } from "../View";
import { ActionButton } from "./ActionButton";
import { CircleButton } from "./CircleButton";
import { CloseIcon } from "../Icons/Close";
import { ImpactedDetails } from "./ImpactedDetails";
import { TickIcon } from "../Icons/Tick";

const useStyles = makeStyles(({ typography }) => ({
  container: {
    backgroundColor: palette.darkGrey,
    width: "100%",
    height: "50px",
    display: "flex",
    alignItems: "center",
  },
  tickIcon: {
    width: "18px",
    height: "20px",
    fill: palette.typography.black.solid,
  },
  closeIcon: {
    width: "18px",
    height: "20px",
    fill: palette.typography.white.solid,
  },
  left10: {
    marginLeft: "10px",
  },
}));

const RouteEditBar = () => {
  const styles = useStyles();
  const routesAffected = useSelector(routesAffectedByEditSelector);
  const overlayDetails = useSelector(overlayDetailsSelector);
  const isPostcodeEditMode = !!useSelector(artificialPostcodeInEditSelector);
  const planType = useSelector(getMatrixProfileType);
  const selectedPostcodes = useSelector(selectedPostcodesSelector);
  const depotRoutesOptimised = useSelector(depotRoutesOptimisedSelector);
  const dispatch = useDispatch();

  const renderButtonsForType = () => {
    if (planType === OVERRIDES_PLAN_TYPE)
      return (
        <ActionButton
          className={styles.left10}
          onClick={() => dispatch(editPostcodesOverrides())}
          disabled={!selectedPostcodes.length}
        >
          Overrides
        </ActionButton>
      );
    else if (planType === PICKUP_PLAN_TYPE)
      return (
        <ActionButton
          className={styles.left10}
          onClick={() => dispatch(editPostcodesPickup())}
          disabled={!selectedPostcodes.length}
        >
          Pickup
        </ActionButton>
      );
    else if (planType === LOCATIONS_PLAN_TYPE) return null;
    else if (planType) {
      return (
        <ActionButton
          disabled={
            !overlayDetails ||
            !depotRoutesOptimised ||
            !routesAffected?.notOptimised?.length
          }
          onClick={() => {
            dispatch(optimiseRouteEditImpact(routesAffected?.allAffected));
          }}
          className={styles.left10}
        >
          Optimise
        </ActionButton>
      );
    } else return null;
  };

  return (
    <View className={styles.container}>
      <CircleButton
        disabled={
          planType !== OVERRIDES_PLAN_TYPE &&
          overlayDetails &&
          depotRoutesOptimised &&
          routesAffected?.notOptimised?.length
        }
        defaultColor={palette.btn.greenFill}
        disabledColor={palette.btn.greenFillTranslucent}
        icon={<TickIcon className={styles.tickIcon} />}
        onClick={() => {
          if (!isPostcodeEditMode) {
            dispatch(applyEdit());
          } else {
            dispatch(applyArtificialPostcodeEdit());
          }
        }}
      />

      <CircleButton
        disabled={false}
        defaultColor={palette.dpdRed}
        disabledColor={palette.btn.dpdRedTranslucent}
        icon={<CloseIcon className={styles.closeIcon} />}
        onClick={() => {
          if (!isPostcodeEditMode) {
            dispatch(cancelEdit());
          } else {
            dispatch(cancelArtificialPostcodeEdit());
          }
        }}
      />
      {renderButtonsForType()}
      <ImpactedDetails />
    </View>
  );
};

export default RouteEditBar;
